import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import "./Pricing.css";

function Pricing() {
  const [isMonthly, setIsMonthly] = useState(true);
  const [pricingData, setPricingData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchPackages = async () => {
      const frequency = isMonthly ? "monthly" : "yearly";
      setLoading(true);
      try {
        const res = await axios.get(
          `https://zola.technology/api/public/packages/list/?frequency=${frequency}`
        );
        setPricingData(res.data || []);
      } catch (err) {
        console.error("Error fetching packages:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchPackages();
  }, [isMonthly]);

  return (
    <section className="pricing-section">
      <h1>Fuel your company’s growth with Zola</h1>
      <p>
        Businesses leveraging 400+ reviews through Zola outperform the average
        by more than double in revenue.
      </p>

      <div className="toggle-pricing">
        <button
          aria-label="Pay Monthly"
          className={isMonthly ? "active" : ""}
          onClick={() => setIsMonthly(true)}
        >
          Pay Monthly
        </button>
        <button
          aria-label="Pay Annually"
          className={!isMonthly ? "active" : ""}
          onClick={() => setIsMonthly(false)}
        >
          Pay Annually
        </button>
      </div>

      {loading ? (
        <p>Loading packages...</p>
      ) : (
        <div className="pricing-cards flex flex-wrap">
          {pricingData.map((pkg, index) => {
            const hasDiscount =
              parseFloat(pkg.total_price) >
              parseFloat(pkg.total_discounted_price);
            return (
              <div
                className={`pricing-card ${
                  pkg.recommended ? "recommended" : ""
                }`}
                key={index}
              >
                {pkg.recommended && (
                  <div className="recommended-header">
                    <h4>Recommended</h4>
                  </div>
                )}
                <div className="pricing-card_header">
                  <h3>{pkg.name}</h3>
                  <h2>
                    ${parseFloat(pkg.total_discounted_price).toFixed(2)}
                    {hasDiscount && (
                      <span>${parseFloat(pkg.total_price).toFixed(2)}</span>
                    )}
                  </h2>
                  <p>
                    {isMonthly
                      ? "Per month billed monthly"
                      : "Per year billed annually"}
                  </p>
                  <hr />
                </div>
                <div className="pricing-card_body">
                  {[...pkg.features]
                    .sort((a, b) =>
                      a.included === b.included ? 0 : a.included ? -1 : 1
                    )
                    .map((featureObj, i) => (
                      <div key={i}>
                        <p
                          className={
                            featureObj.included ? "" : "striked-text disabled text-gray-400"
                          }
                        >
                          {featureObj.feature?.name}
                        </p>
                        <hr />
                      </div>
                    ))}
                </div>

                <div className="pricing-card_footer">
                  <Link>Start free 14-day trial</Link>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </section>
  );
}

export default Pricing;
